import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-title">{t('footerTitle')}</div>
      <div className="footer-contact">
        {t('footerContact')} <a href="mailto:marketing@buglo.pl">marketing@buglo.pl</a>
      </div>
      <div className="footer-copyright">
        <div className="copy">
            © <a href="https://buglo.pl">Buglo.pl</a> - {t('footerCopyright')}
        </div>
        <div className="author">{t('footerCreated')}</div>
      </div>
    </footer>
  );
};

export default Footer;
